module.exports = __webpack_public_path__ + "static/img/s66.8ff55946.png";